import React, { useState } from "react";
import "./UploadOpportunities.css";
import Patron_Navbar from "../Patron_Navbar";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useSelector } from "react-redux";
import { makeAuthenticatedPOSTRequest } from "../../services/serverHelper";
import { patronProfilePoints } from "../../services/apis";
import { useNavigate } from "react-router-dom";
import {
  AiOutlineUpload,
  AiOutlineFileText,
  AiOutlineCalendar,
  AiOutlineUser,
  AiOutlineMail,
  AiOutlinePhone,
} from "react-icons/ai";
import { MdLocationOn, MdTheaters } from "react-icons/md";

function UploadOpportunities() {
  const { accessToken } = useSelector((state) => state.auth);
  const [formData, setFormData] = useState({});
  const [uploadTab, setUploadTab] = useState(1);
  const [stateData, setStateData] = useState('')
  const [city, setCity] = useState('');
  const navigate = useNavigate();

  const inputChangeHandler = (e) => {
    setFormData((prevState) => {
      if (e.target.name === "start" || e.target.name === "end") {
        const applicationPeriod = {
          [e.target.name]: e.target.value,
        };

        return {
          ...prevState,
          applicationPeriod: {
            ...prevState.applicationPeriod,
            ...applicationPeriod,
          },
        };
      }

      return { ...prevState, [e.target.name]: e.target.value };
    });
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    setFormData({
      ...formData,
      location:{
        state:stateData,
        city:city
      },
      contactPersonName: "william",
      contactEmail: "william@gmail.com",
      contactPersonNumber: "1234567890",
    });

    console.log(formData);
    const toastId = toast.loading("Loading...");

    try {
      const response = await makeAuthenticatedPOSTRequest(
        patronProfilePoints.UPLOAD_OPPOR_API,
        formData,
        accessToken
      );

      if (response.statusCode === 201) {
        toast.success("Successfully uploaded");

        setFormData((prevState) => ({
          ...prevState,
          applicationPeriod: {
            start: "",
            end: "",
          },
        }));

        setFormData((prevState) => ({
          ...prevState,
          artNature: "",
          location: "",
          description: "",
        }));

        navigate("/UploadedOpportunities");
      } else {
        console.log(response.message);
        toast.error("Please provide all the required fields");
      }
    } catch (error) {
      console.log(error);
      toast.error("something went wrong, please try again");
    }
    toast.dismiss(toastId);
  };

  let allLanguages = [
    "Assamese", "Bengali", "Bhili", "Bhojpuri", "Dogri", "Garhwali",
    "Gujarati", "Haryanvi", "Hindi", "Kannada", "Kashmiri", "Khasi",
    "Kokborok", "Konkani", "Kumaoni", "Maithili", "Malayalam", "Manipuri",
    "Marathi", "Mizo (Lushai)", "Nepali", "Odia", "Punjabi", "Rajasthani",
    "Santali", "Sindhi", "Tamil", "Telugu", "Tulu", "Urdu", "English",
    "Spanish", "French", "German", "Italian", "Portuguese",
    "Chinese (Simplified)", "Japanese", "Korean", "Russian",
  ];

  const purposeOfPerformance = [
    "Annual / Foundation Day", "Conference/ Workshop/ Training",
    "Employee Engagement", "Family functions",
    "National/ State Day Celebration", "Office Functions",
    "Performance for hotel guests", "Product Launch",
    "Special Day – Marriage, Anniversary", "Special Events", "Any other",
  ];

  const indianStates = [
    "Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chhattisgarh",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Odisha",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
    "Tripura",
    "Uttar Pradesh",
    "Uttarakhand",
    "West Bengal",
  ];

  const citiesByState = {
    "Andhra Pradesh": ["Visakhapatnam", "Vijayawada", "Guntur", "Nellore", "Kurnool"],
    "Arunachal Pradesh": ["Itanagar", "Naharlagun", "Tawang", "Pasighat", "Ziro"],
    Assam: ["Guwahati", "Jorhat", "Dibrugarh", "Silchar", "Nagaon"],
    Bihar: ["Patna", "Gaya", "Muzaffarpur", "Bhagalpur", "Darbhanga"],
    Chhattisgarh: ["Raipur", "Bhilai", "Bilaspur", "Korba", "Raigarh"],
    Goa: ["Panaji", "Vasco da Gama", "Margao", "Mapusa", "Ponda"],
    Gujarat: ["Ahmedabad", "Surat", "Vadodara", "Rajkot", "Gandhinagar"],
    Haryana: ["Faridabad", "Gurugram", "Rohtak", "Panipat", "Karnal"],
    "Himachal Pradesh": ["Shimla", "Mandi", "Solan", "Dharamshala", "Kullu"],
    Jharkhand: ["Ranchi", "Jamshedpur", "Dhanbad", "Bokaro", "Hazaribagh"],
    Karnataka: ["Bangalore", "Mysore", "Hubli", "Mangalore", "Belgaum"],
    Kerala: ["Thiruvananthapuram", "Kochi", "Kozhikode", "Thrissur", "Kollam"],
    "Madhya Pradesh": ["Bhopal", "Indore", "Jabalpur", "Gwalior", "Ujjain"],
    Maharashtra: ["Mumbai", "Pune", "Nagpur", "Nashik", "Aurangabad"],
    Manipur: ["Imphal", "Thoubal", "Bishnupur", "Churachandpur", "Kakching"],
    Meghalaya: ["Shillong", "Tura", "Jowai", "Nongpoh", "Williamnagar"],
    Mizoram: ["Aizawl", "Lunglei", "Champhai", "Saiha", "Kolasib"],
    Nagaland: ["Kohima", "Dimapur", "Mokokchung", "Tuensang", "Wokha"],
    Odisha: ["Bhubaneswar", "Cuttack", "Rourkela", "Berhampur", "Sambalpur"],
    Punjab: ["Ludhiana", "Amritsar", "Jalandhar", "Patiala", "Bathinda"],
    Rajasthan: ["Jaipur", "Jodhpur", "Udaipur", "Kota", "Bikaner"],
    Sikkim: ["Gangtok", "Namchi", "Mangan", "Singtam", "Gyalshing"],
    "Tamil Nadu": ["Chennai", "Coimbatore", "Madurai", "Tiruchirappalli", "Salem"],
    Telangana: ["Hyderabad", "Warangal", "Nizamabad", "Karimnagar", "Khammam"],
    Tripura: ["Agartala", "Dharmanagar", "Udaipur", "Kailashahar", "Belonia"],
    "Uttar Pradesh": ["Lucknow", "Kanpur", "Agra", "Varanasi", "Allahabad"],
    Uttarakhand: ["Dehradun", "Haridwar", "Roorkee", "Haldwani", "Rudrapur"],
    "West Bengal": ["Kolkata", "Howrah", "Durgapur", "Asansol", "Siliguri"],
  };

  const ArtNames = [
    "Bharatanatyam", "Bihu", "Chhau", "Dandiya Raas", "Dollu Kunitha",
    "Dumhal", "Garba", "Gaur Dance", "Giddha", "Gotipua", "Jhumar",
    "Kacchi Ghodi", "Kalbelia", "Karakattam", "Kathak", "Kathakali",
    "Kathakar", "Koli", "Kuchipudi", "Lavani", "Manipuri",
    "Mayurbhanj Chhau", "Mohiniyattam", "Odissi", "Raas Leela",
    "Sattriya", "Tamasha", "Tera Tali", "Thang-Ta", "Yakshagana",
    "Dhrupad", "Khayal", "Thumri", "Tappa", "Ghazal", "Qawwali",
    "Kriti", "Varnam", "Tillana", "Ragamalika", "Javali", "Swarajati",
    "Bhajans", "Kirtan", "Sufi Music", "Abhangas", "Shabad Kirtan (Sikh)",
    "Bansuri", "Dilruba", "Dholak", "Ektara", "Esraj", "Flute (Bansuri)",
    "Ghatam", "Harmonium", "Jal Tarang", "Mridangam", "Nadaswaram",
    "Pakhawaj", "Ravanahatha", "Sarangi", "Sarod", "Santoor", "Shehnai",
    "Sitar", "Tabla", "Tanpura", "Tumbi", "Veena", "Bhavai",
    "Bhand Pather", "Jatra", "Koodiyattam", "Mudiyettu", "Nautanki",
    "Pandavani", "Pothu Koothu", "Ramlila", "Ram Lila", "Ras Leela",
    "Sattriya", "Tamaasha", "Therukoothu", "Yakshagana",
  ];

  const venueTypes = [
    "Banquette Hall", "Classroom", "Corporate", "Hotel", "Open Ground",
    "Private House", "Theater", "Training Center", "Any other",
  ];

  const performanceFacilitiesaArr = [
    "Accommodation", "Food", "Light", "Local Travel", "Musical Instruments",
    "Outstation Travel", "Photography", "Sound", "Stage", "Video", "Any other",
  ];

  return (
    <>
      <Patron_Navbar />
      <div className="modern_upload_opp_page">
        {/* Hero Section */}
        <div className="modern_upload_hero">
          <div className="modern_upload_hero_overlay">
            <h1 className="modern_upload_hero_title">
              Upload Opportunities for Artists
            </h1>
            <p className="modern_upload_hero_subtitle">
              Connect with talented artists and bring your vision to life
            </p>
          </div>
        </div>

        <div className="modern_upload_container">
          {/* Tabs */}
          <div className="modern_upload_tabs">
            <button
              className={`modern_upload_tab ${uploadTab === 1 ? "active" : ""}`}
              onClick={() => setUploadTab(1)}
            >
              <AiOutlineUpload className="modern_tab_icon" />
              Upload Opportunities
            </button>
            {/* <button
              className={`modern_upload_tab ${uploadTab === 2 ? "active" : ""}`}
              onClick={() => setUploadTab(2)}
            >
              <AiOutlineFileText className="modern_tab_icon" />
              Uploaded Opportunities
            </button> */}
          </div>

          {/* Form */}
          <form onSubmit={submitHandler} className="modern_upload_form">
            {/* Performance Details Section */}
            <div className="modern_upload_section">
              <h2 className="modern_section_title">
                <MdTheaters className="modern_section_icon" />
                Performance Details
              </h2>
              <div className="modern_form_grid">
                <div className="modern_form_field modern_full_width">
                  <label className="modern_form_label">Purpose of Performance*</label>
                  <select
                    required
                    name="purpose"
                    value={formData?.purpose}
                    onChange={inputChangeHandler}
                    className="modern_form_input"
                  >
                    <option value="" hidden>Select purpose</option>
                    {purposeOfPerformance?.map((item, index) => (
                      <option value={item} key={index}>{item}</option>
                    ))}
                  </select>
                </div>

                <div className="modern_form_field modern_full_width">
                  <label className="modern_form_label">Description*</label>
                  <input
                    required
                    name="description"
                    value={formData?.description}
                    onChange={inputChangeHandler}
                    type="text"
                    className="modern_form_input"
                    placeholder="Enter art description"
                  />
                </div>

                <div className="modern_form_field">
                  <label className="modern_form_label">Location of Performance (State)*</label>
                  <select
                    onChange={e => setStateData(e.target.value)}
                    name="location"
                    // value={stateData}
                    required
                    className="modern_form_input"
                  >
                    <option value="" hidden>Select State</option>
                    {indianStates.map((state) => (
                      <option key={state} value={state}>
                        {state}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="modern_edit_field">
                  <label className="modern_edit_label">City*</label>
                  <select
                    name="address.city"
                    onChange={e => setCity(e.target.value)}
                    // value={formData.address.city}
                    className="modern_edit_input"
                    required
                  >
                    <option value="">Select City</option>
                    {stateData &&
                      citiesByState[stateData] &&
                      citiesByState[stateData].map((city) => (
                        <option key={city} value={city}>
                          {city}
                        </option>
                      ))}
                  </select>
                </div>

                <div className="modern_form_field">
                  <label className="modern_form_label">Language of Performance</label>
                  <select
                    onChange={inputChangeHandler}
                    name="languages"
                    value={formData?.languages}
                    className="modern_form_input"
                  >
                    <option value="">Select Language</option>
                    {allLanguages?.map((item, index) => (
                      <option value={item} key={index}>{item}</option>
                    ))}
                  </select>
                </div>

                <div className="modern_form_field">
                  <label className="modern_form_label">Approx. Budget*</label>
                  <select
                    required
                    onChange={inputChangeHandler}
                    value={formData?.budget}
                    name="budget"
                    className="modern_form_input"
                  >
                    <option value="" hidden>Select budget</option>
                    <option value="24000">Below 25000</option>
                    <option value="35000">25000-50000</option>
                    <option value="70000">50000-100000</option>
                    <option value="200000">100000-250000</option>
                    <option value="800000">250000-1000000</option>
                    <option value="1200000">Above 1000000</option>
                  </select>
                </div>

                <div className="modern_form_field">
                  <label className="modern_form_label">Date of Performance*</label>
                  <input
                    required
                    value={formData?.performanceDate}
                    name="performanceDate"
                    onChange={inputChangeHandler}
                    type="date"
                    className="modern_form_input"
                  />
                </div>

                <div className="modern_form_field">
                  <label className="modern_form_label">Duration (hrs)*</label>
                  <input
                    required
                    onChange={inputChangeHandler}
                    value={formData?.performanceDuration}
                    name="performanceDuration"
                    type="number"
                    className="modern_form_input"
                    placeholder="Enter duration"
                  />
                </div>

                <div className="modern_form_field">
                  <label className="modern_form_label">Application Last Date*</label>
                  <input
                    required
                    onChange={inputChangeHandler}
                    name="end"
                    value={formData?.applicationPeriod?.end}
                    type="date"
                    className="modern_form_input"
                  />
                </div>
              </div>
            </div>

            {/* Art Details Section */}
            <div className="modern_upload_section">
              <h2 className="modern_section_title">
                <AiOutlineFileText className="modern_section_icon" />
                Art Details
              </h2>
              <div className="modern_form_grid">
                <div className="modern_form_field">
                  <label className="modern_form_label">Type of Art*</label>
                  <select
                    required
                    value={formData?.artType}
                    name="artType"
                    onChange={inputChangeHandler}
                    className="modern_form_input"
                  >
                    <option value="">Select Art</option>
                    <option value="Folk">Folk</option>
                    <option value="Classical">Classical</option>
                    <option value="Fusion">Fusion</option>
                    <option value="Other">Other</option>
                  </select>
                </div>

                <div className="modern_form_field">
                  <label className="modern_form_label">Category of Art*</label>
                  <select
                    required
                    onChange={inputChangeHandler}
                    name="artCategory"
                    value={formData?.artCategory}
                    className="modern_form_input"
                  >
                    <option value="">Select Category</option>
                    <option value="dance">Dance</option>
                    <option value="song">Song</option>
                    <option value="music">Music</option>
                    <option value="theater">Theater</option>
                    <option value="Other">Other</option>
                  </select>
                </div>

                <div className="modern_form_field">
                  <label className="modern_form_label">Name of Art*</label>
                  <select
                    required
                    value={formData?.artName}
                    name="artName"
                    onChange={inputChangeHandler}
                    className="modern_form_input"
                  >
                    <option value="" hidden>Select art name</option>
                    {ArtNames?.map((item, index) => (
                      <option value={item} key={index}>{item}</option>
                    ))}
                  </select>
                </div>

                <div className="modern_form_field">
                  <label className="modern_form_label">Theme of Performance*</label>
                  <input
                    required
                    onChange={inputChangeHandler}
                    value={formData?.theme}
                    name="theme"
                    type="text"
                    className="modern_form_input"
                    placeholder="Enter theme"
                  />
                </div>

                <div className="modern_form_field">
                  <label className="modern_form_label">Live/Recorded/Part Live</label>
                  <select
                    onChange={inputChangeHandler}
                    name="mediaType"
                    className="modern_form_input"
                  >
                    <option value="" hidden>Select type</option>
                    <option value="Live">Live</option>
                    <option value="Recorded">Recorded</option>
                    <option value="PartLive">Part Live</option>
                    <option value="other">Other</option>
                  </select>
                </div>

                <div className="modern_form_field">
                  <label className="modern_form_label">Need Customized Performance</label>
                  <select
                    onChange={inputChangeHandler}
                    name="customization"
                    className="modern_form_input"
                  >
                    <option value="" hidden>Select option</option>
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </select>
                </div>
              </div>
            </div>

            {/* Artist Requirements Section */}
            <div className="modern_upload_section">
              <h2 className="modern_section_title">
                <AiOutlineUser className="modern_section_icon" />
                Artist Requirements
              </h2>
              <div className="modern_form_grid">
                <div className="modern_form_field">
                  <label className="modern_form_label">No. of Required Artists*</label>
                  <select
                    required
                    value={formData?.requiredArtists}
                    name="requiredArtists"
                    onChange={inputChangeHandler}
                    className="modern_form_input"
                  >
                    <option value="" hidden>Select count</option>
                    <option value="1">1</option>
                    <option value="3">2-5</option>
                    <option value="7">5-10</option>
                    <option value="20">10-50</option>
                    <option value="60">Above 50</option>
                  </select>
                </div>

                <div className="modern_form_field">
                  <label className="modern_form_label">Level of Artist*</label>
                  <select
                    required
                    onChange={inputChangeHandler}
                    value={formData?.artistLevel}
                    name="artistLevel"
                    className="modern_form_input"
                  >
                    <option value="" hidden>Select level</option>
                    <option value="international">International</option>
                    <option value="national">National</option>
                    <option value="state">State</option>
                    <option value="district">District</option>
                    <option value="taluka">Taluka</option>
                    <option value="local">Local</option>
                    <option value="Others">Others</option>
                  </select>
                </div>

                <div className="modern_form_field">
                  <label className="modern_form_label">Location of Artist*</label>
                  <select
                    onChange={inputChangeHandler}
                    name="artistLocation"
                    value={formData?.artistLocation}
                    required
                    className="modern_form_input"
                  >
                    <option value="" hidden>Select location</option>
                    <option value="local">Local</option>
                    <option value="outstation">Outstation</option>
                    <option value="Others">Others</option>
                  </select>
                </div>
              </div>
            </div>

            {/* Venue & Audience Section */}
            <div className="modern_upload_section">
              <h2 className="modern_section_title">
                <MdLocationOn className="modern_section_icon" />
                Venue & Audience
              </h2>
              <div className="modern_form_grid">
                <div className="modern_form_field">
                  <label className="modern_form_label">Size of Audience*</label>
                  <select
                    onChange={inputChangeHandler}
                    name="audienceSize"
                    value={formData?.audienceSize}
                    required
                    className="modern_form_input"
                  >
                    <option value="" hidden>Select size</option>
                    <option value="20">Below 25</option>
                    <option value="35">25-50</option>
                    <option value="70">50-100</option>
                    <option value="300">100-500</option>
                    <option value="800">500-1000</option>
                    <option value="1200">Above 1000</option>
                  </select>
                </div>

                <div className="modern_form_field">
                  <label className="modern_form_label">Profile of Audience*</label>
                  <select
                    onChange={inputChangeHandler}
                    name="audienceProfile"
                    value={formData?.audienceProfile}
                    required
                    className="modern_form_input"
                  >
                    <option value="" hidden>Select profile</option>
                    <option value="Hotel inhouse Guests">Hotel inhouse Guests</option>
                    <option value="Professional/ Executives">Professional/ Executives</option>
                    <option value="Students">Students</option>
                    <option value="Family Guests">Family Guests</option>
                  </select>
                </div>

                <div className="modern_form_field">
                  <label className="modern_form_label">Venue of Performance*</label>
                  <select
                    onChange={inputChangeHandler}
                    name="venue"
                    value={formData?.venue}
                    required
                    className="modern_form_input"
                  >
                    <option value="" hidden>Select venue</option>
                    {venueTypes?.map((item, index) => (
                      <option value={item} key={index}>{item}</option>
                    ))}
                  </select>
                </div>

                <div className="modern_form_field">
                  <label className="modern_form_label">Performance Facilities*</label>
                  <select
                    onChange={inputChangeHandler}
                    name="facilities"
                    value={formData?.facilities}
                    required
                    className="modern_form_input"
                  >
                    <option value="" hidden>Select facilities</option>
                    {performanceFacilitiesaArr?.map((item, index) => (
                      <option value={item} key={index}>{item}</option>
                    ))}
                  </select>
                </div>

                <div className="modern_form_field modern_full_width">
                  <label className="modern_form_label">Any Other Requirements</label>
                  <textarea
                    onChange={inputChangeHandler}
                    name="otherRequirements"
                    value={formData?.otherRequirements}
                    className="modern_form_textarea"
                    placeholder="Enter any additional requirements..."
                  />
                </div>
              </div>
            </div>

            {/* Contact Section */}
            <div className="modern_upload_section">
              <h2 className="modern_section_title">
                <AiOutlinePhone className="modern_section_icon" />
                Contact Information
              </h2>
              <div className="modern_form_grid">
                <div className="modern_form_field">
                  <label className="modern_form_label">Name</label>
                  <input
                    value="william wilson"
                    name="Name"
                    type="text"
                    className="modern_form_input"
                    placeholder="Name of User"
                    readOnly
                  />
                </div>

                <div className="modern_form_field">
                  <label className="modern_form_label">Contact Number</label>
                  <input
                    value="1234567890"
                    name="ContactNumber"
                    type="text"
                    className="modern_form_input"
                    placeholder="Contact Number"
                    readOnly
                  />
                </div>

                <div className="modern_form_field">
                  <label className="modern_form_label">Email</label>
                  <input
                    value="william@gmail.com"
                    name="Email"
                    type="text"
                    className="modern_form_input"
                    placeholder="Email of User"
                    readOnly
                  />
                </div>
              </div>
            </div>

            {/* Submit Button */}
            <div className="modern_upload_submit_wrapper">
              <button type="submit" className="modern_upload_submit_btn">
                <AiOutlineUpload className="modern_submit_icon" />
                Upload Opportunity
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default UploadOpportunities;